<div class="container pb-13">
  <lib-web-shared-ui-page-header [data]="pageHeaderObj()" (emitPathUrl)="redirectTo($event)"></lib-web-shared-ui-page-header>

  <lib-web-shared-ui-terms-and-condition [data]="termsAndConditionObj"></lib-web-shared-ui-terms-and-condition>
</div>
